import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IconName } from '../../enums/icon-enum';
import { ICON_PATH } from '../../constants/icon-map.constants';

@Component({
  selector: 'app-icon',
  imports: [],
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
  public icon = input.required<IconName>();
  public iconPath = computed(() => ICON_PATH[this.icon()]);
}
